import { addDays, parse } from "date-fns";
import { clearListCache, createKey, get } from "@/utils/networkCache";
import { models, request } from "leatherman-js";
import Status from "@/classes/Status";
import { updateList } from "@/utils/storeHelper";

// get the expiration date in seconds since epoch
// the legacy app sets the expiration to the 15th of the month noted on the card; continuing that convetion here but may change in future.
const formatExpiration = (exp) =>
  addDays(parse(exp, "MM/yyyy", new Date(2020, 15, 1)), 15).getTime() / 1000;

const creditcards = {
  namespaced: true,
  state: {
    status: new Status(),
    creditcard: new models.CreditCard(),
    list: [],
    pagination: null,
    sort: null,
  },
  mutations: {
    SET_STATUS(state, payload) {
      state.status.value = payload;
    },
    SET_LIST(state, payload) {
      state.list = payload;
    },
    SET_PAGINATION(state, payload) {
      state.pagination = payload;
    },
    SET_CREDITCARD(state, payload) {
      state.creditcard = payload;
    },
  },
  actions: {
    async create({ dispatch, commit, state }, { name, number, expiration, csv }) {
      // new card to be created
      const card = {
        name: name,
        expiration: formatExpiration(expiration),
        number: number,
        cvv: csv,
      };

      const creditCard = await request.makeParse("createCreditCard", {}, card);
      commit("SET_CREDITCARD", creditCard);
      clearListCache("getCreditCards");
      updateList(dispatch, state);
      return creditCard;
    },
    async update({ dispatch, commit, state }, { id, name, expiration }) {
      // updated fields
      const card = {
        expiration: formatExpiration(expiration),
        name: name,
      };
      const creditCard = await request.makeParse("updateCreditCard", { id }, card);
      commit("SET_CREDITCARD", creditCard);
      clearListCache("getCreditCards");
      updateList(dispatch, state);
      return creditCard;
    },
    async getList({ commit }, params) {
      commit("SET_STATUS", Status.LOADING);
      const cards = await get(createKey("getCreditCards", params), request.makeParse, [
        "getCreditCards",
        params,
      ]);
      commit("SET_LIST", cards.list);
      commit("SET_PAGINATION", cards.pagination);
      commit("SET_STATUS", Status.LOADED);
      return cards;
    },
    async getCreditcard({ commit }, id) {
      const res = await get(createKey("creditcards", { id }), request.makeParse, [
        "getCreditCard",
        { id },
      ]);
      commit("SET_CREDITCARD", res);
      return res;
    },
    async deleteCreditCard({ dispatch }, { id }) {
      return request.makeParse("deleteCreditCard", { id }).finally(() => {
        clearListCache(createKey("getCreditCards"));
        dispatch("getList");
      });
    },
    async setPrimary({ dispatch }, { id }) {
      return request.makeParse("setPrimary", { id }).finally(() => {
        clearListCache(createKey("getCreditCards"));
        dispatch("getList");
      });
    },
    refreshList({ dispatch }) {
      clearListCache(createKey("getCreditCards"));
      dispatch("getList");
    },
  },
  getters: {
    primary: (state) => {
      return state.list.find((card) => card.primary);
    },
    cards: (state) => {
      return state.list;
    },
  },
};

export default creditcards;
